import { salesOrderFilterAtoms } from '@/features/finance/sales-orders/filters.ts';
import { salesOrderPaginationAtom } from '@/features/finance/sales-orders/pagination.ts';
import { getSalesOrdersQueryKey } from '@/features/finance/sales-orders/queries/getSalesOrders.ts';
import { salesOrderSortAtom } from '@/features/finance/sales-orders/sorting.ts';
import {
  getSalesOrderControllerGetSalesOrderNotesQueryKey,
  salesOrderControllerCreateSalesOrderNote,
  salesOrderControllerCreateSalesOrderNoteWithAttachments,
} from '@/generated/api/sales-order.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

export default function useCreateSalesOrderNote() {
  const filter = useAtomValue(salesOrderFilterAtoms.valuesAtom);
  const pagination = useAtomValue(salesOrderPaginationAtom);
  const sorting = useAtomValue(salesOrderSortAtom.sortAtom);
  const salesOrdersQueryKey = getSalesOrdersQueryKey(
    filter,
    pagination,
    sorting,
  );

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      salesOrderId,
      data,
    }: {
      salesOrderId: string;
      data: { message: string; files?: File[] };
    }) =>
      data.files?.length
        ? salesOrderControllerCreateSalesOrderNoteWithAttachments(
            salesOrderId,
            { message: data.message, files: data.files },
          )
        : salesOrderControllerCreateSalesOrderNote(salesOrderId, {
            message: data.message,
          }),
    onSuccess: (notes, variables) => {
      queryClient.setQueryData(
        getSalesOrderControllerGetSalesOrderNotesQueryKey(
          variables.salesOrderId,
        ),
        notes,
      );
      queryClient.invalidateQueries({ queryKey: salesOrdersQueryKey });
    },
  });
}
